
import { Phone, MessageSquare, Bot } from 'lucide-react';
import { motion } from 'framer-motion';
import { SITE_INFO, getWhatsAppUrl } from '../content/site-info';

const TopBar = () => {
  const handleOpenChatbot = () => {
    const openButton = document.querySelector('button[aria-label="Abrir chat"]');
    if (openButton instanceof HTMLElement) {
      openButton.click();
      setTimeout(() => {
        openButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }, 100);
      return;
    }

    const closeButton = document.querySelector('button[aria-label="Fechar chat"]');
    if (!(closeButton instanceof HTMLElement)) return;
    closeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  };

  return (
    <motion.div
      role="region"
      aria-label="Informações de contato"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="sticky top-0 z-50 bg-gradient-to-r from-gray-700 via-gray-700 to-gray-800 
                 text-white border-b border-gray-600/50 backdrop-blur-md 
                 shadow-sm"
    >
      <div className="container-responsive">
        <div className="flex items-center justify-between gap-1 xs:gap-2 xs2:gap-3 
                       sm:gap-4 py-1.5 xs:py-2 sm:py-2.5 overflow-hidden">
          
          {/* Telefone - Responsivo para todos os breakpoints */}
          <motion.address 
            className="not-italic flex items-center gap-0.5 xs:gap-1 xs2:gap-1.5 
                      shrink-0 min-w-0 group"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            <Phone 
              size={12} 
              className="xs:w-3.5 xs:h-3.5 xs2:w-4 xs2:h-4 sm:w-4 sm:h-4 
                       md:w-5 md:h-5 shrink-0 text-gray-300 group-hover:text-white 
                       transition-colors" 
              aria-hidden="true"
            />
            <a
              href={`tel:${SITE_INFO.phone.tel}`}
              className="hover:text-white transition-colors text-[10px] xs:text-xs 
                       xs2:text-sm sm:text-base md:text-lg truncate font-medium"
              aria-label={`Ligar para ${SITE_INFO.phone.display}`}
            >
              <span className="hidden xs:inline">(21) </span>
              <span>994023817</span>
            </a>
          </motion.address>

          {/* WhatsApp - Responsivo para todos os breakpoints */}
          <motion.a
            href={getWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-0.5 xs:gap-1 xs2:gap-1.5 shrink-0 
                      hover:text-green-400 transition-colors group"
            aria-label="Abrir conversa no WhatsApp"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            <MessageSquare 
              size={12} 
              className="xs:w-3.5 xs:h-3.5 xs2:w-4 xs2:h-4 sm:w-4 sm:h-4 
                        md:w-5 md:h-5 shrink-0 text-gray-300 group-hover:text-green-400 
                        transition-colors" 
              aria-hidden="true"
            />
            <span className="text-[10px] xs:text-xs xs2:text-sm sm:text-base 
                           md:text-lg whitespace-nowrap font-medium">
              <span className="hidden xs2:inline">WhatsApp</span>
              <span className="xs2:hidden">WA</span>
            </span>
          </motion.a>

          {/* Atendimento - Responsivo para todos os breakpoints */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            <button
              type="button"
              onClick={handleOpenChatbot}
              className="flex items-center gap-0.5 xs:gap-1 xs2:gap-1.5 shrink-0 
                       hover:text-primary-400 transition-colors group"
              aria-label="Abrir chatbot de atendimento"
            >
              <Bot 
                size={12} 
                className="xs:w-3.5 xs:h-3.5 xs2:w-4 xs2:h-4 sm:w-4 sm:h-4 
                          md:w-5 md:h-5 shrink-0 text-gray-300 group-hover:text-primary-400 
                          transition-colors" 
                aria-hidden="true"
              />
              <span className="text-[10px] xs:text-xs xs2:text-sm sm:text-base 
                             md:text-lg whitespace-nowrap font-medium">
                <span className="hidden xs3:inline">Atendimento</span>
                <span className="xs3:hidden">Chat</span>
              </span>
            </button>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default TopBar;



